import React from 'react';
import { Clock, Target, TrendingUp, FileCheck } from 'lucide-react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: Clock,
  title: 'Ahorrás horas en cada consulta',
  description: 'Protocolos y planillas listas desde el primer día.'
}, {
  icon: Target,
  title: 'Resolvés casos complejos con confianza',
  description: 'Casos clínicos resueltos paso a paso.'
}, {
  icon: TrendingUp,
  title: 'Mejorás adherencia y resultados',
  description: 'Sistemas probados para mejores resultados.'
}, {
  icon: FileCheck,
  title: 'Sistema completo replicable',
  description: 'Todo listo para implementar en tu consultorio.'
}];
export function Benefits() {
  return <section className="w-full py-10 md:py-14 bg-gradient-to-b from-white to-emerald-50" data-id="element-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-6" data-id="element-26">
          <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-1.5 rounded-full text-xs font-bold mb-3" data-id="element-27">
            ✨ LO QUE VAS A CONSEGUIR
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900" data-id="element-28">
            Beneficios del <span className="text-emerald-600" data-id="element-29">Megapack</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-3" data-id="element-30">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3
          }} className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 hover:shadow-md transition-shadow duration-300" data-id="element-31">
                <div className="flex items-start gap-3" data-id="element-32">
                  <div className="bg-emerald-100 rounded-lg p-2 flex-shrink-0" data-id="element-33">
                    <Icon className="w-5 h-5 text-emerald-600" data-id="element-34" />
                  </div>
                  <div className="flex-1" data-id="element-35">
                    <h3 className="font-bold text-slate-900 text-sm md:text-base leading-tight mb-1" data-id="element-36">
                      {benefit.title}
                    </h3>
                    <p className="text-slate-600 text-xs md:text-sm leading-snug" data-id="element-37">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}